// Vertical Comparison Slider Component
/** @type {PointerEvent | null} */
let currentPointerEvent = null;

class VerticalComparisonSliderComponent extends HTMLElement {
  constructor() {
    super();
    /** @type {Element | null} */
    this.mediaWrapper = null;
    /** @type {HTMLInputElement | null} */
    this.slider = null;
    /** @type {Element | null} */
    this.handle = null;
    /** @type {boolean} */
    this.isDragging = false;
    /** @type {((e: PointerEvent) => void) | null} */
    this.pointerMoveHandler = null;
    /** @type {((e: PointerEvent) => void) | null} */
    this.pointerUpHandler = null;
  }

  connectedCallback() {
    this.initialize();
    this.setupEventListeners();
  }

  initialize() {
    this.mediaWrapper = this.querySelector('[data-vertical-comparison-slider]');
    this.slider = this.querySelector('.vcs-slider');
    this.handle = this.querySelector('.vcs-slider__handle');

    if (this.mediaWrapper && this.slider && this.slider instanceof HTMLInputElement) {
      this.updateCompareValue(this.slider.value);
    }
  }

  setupEventListeners() {
    if (!this.slider) return;

    // Eventos de input
    this.slider.addEventListener('input', (e) => {
      if (e.target instanceof HTMLInputElement) {
        this.updateCompareValue(e.target.value);
      }
    });

    // Eventos de touch/mouse
    this.slider.addEventListener('pointerdown', () => {
      this.isDragging = true;
      if (this.slider instanceof HTMLInputElement) {
        this.slider.focus();
      }
    });
    
    // Crear referencias para poder remover después
    this.pointerMoveHandler = (e) => {
      if (this.isDragging && this.mediaWrapper) {
        const rect = this.mediaWrapper.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));

        if (this.slider instanceof HTMLInputElement) {
          this.slider.value = String(percentage);
        }
        this.updateCompareValue(String(percentage));
      }
    };

    this.pointerUpHandler = () => {
      this.isDragging = false;
    };
    
    document.addEventListener('pointermove', this.pointerMoveHandler);
    document.addEventListener('pointerup', this.pointerUpHandler);

    // Evento de resize
    window.addEventListener('resize', () => this.updateLayout());
  }

  /**
   * @param {string} value
   */
  updateCompareValue(value) {
    if (this.mediaWrapper && this.mediaWrapper instanceof HTMLElement) {
      this.mediaWrapper.style.setProperty('--compare', value);
    }
  }

  updateLayout() {
    // Método para actualizaciones de layout si es necesario
  }

  disconnectedCallback() {
    if (this.pointerMoveHandler) {
      document.removeEventListener('pointermove', this.pointerMoveHandler);
    }
    if (this.pointerUpHandler) {
      document.removeEventListener('pointerup', this.pointerUpHandler);
    }
  }
}

// Registrar el custom element
customElements.define('vertical-comparison-slider-component', VerticalComparisonSliderComponent);

// Registrar el custom element
customElements.define('vertical-comparison-slider-component', VerticalComparisonSliderComponent);
